module.exports = __webpack_public_path__ + "static/media/home10.465c962a.jpg";